import React from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const PolicyLayout = ({ title, lastUpdated, sections }) => {
  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden mt-2">
        
        {/* HERO SECTION */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#083B5C" }}>
          <div className="container py-lg-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h1 className="font-weight-bold montserrat text-white mb-3" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  {title}
                </h1>
                <p className="text-white opacity-75 font-size-18 mb-0">
                  Last Updated: {lastUpdated}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CONTENT SECTION */}
        <section className="py-5 my-4">
          <div className="container py-lg-4">
            <div className="row g-5">
              
              {/* Sidebar */}
              <div className="col-lg-4 d-none d-lg-block">
                <div className="position-sticky" style={{ top: "120px" }}>
                  <div className="card border-0 shadow-sm rounded-4 p-4" style={{ backgroundColor: "#f4f7f6" }}>
                    <h5 className="font-weight-bold text-primary mb-3">Table of Contents</h5>
                    <ul className="list-unstyled mb-0 font-size-15" style={{ lineHeight: "2.2" }}>
                      {sections.map((section, idx) => (
                        <li key={idx}>
                          <a href={`#section-${idx}`} className="text-muted text-decoration-none">
                            {section.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Main Content */}
              <div className="col-lg-8">
                <div className="policy-content text-muted font-size-16 line-hight-3">
                  {sections.map((section, idx) => (
                    <div key={idx} id={`section-${idx}`} className="mb-5">
                      <h3 className="font-weight-bold text-primary font-size-28 mb-3">{section.title}</h3>
                      <div dangerouslySetInnerHTML={{ __html: section.content }} />
                    </div>
                  ))}
                  
                
                </div>
              </div>

            </div>
          </div>
        </section>
      </main>
      <ClientFooter />
    </>
  );
};

export default PolicyLayout;